module.exports = __webpack_public_path__ + "e01e49af1de2f91c5904d4c4ce79e6c6.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/minimal/purple.png
// module id = 313
// module chunks = 0